import React, { Component } from 'react';
import Slider from 'react-slick';

// type：{btn, right_score_btn, img_btn}

class WSlider extends Component 
{
  render() 

  { 
    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      arrows: false,
      autoplay: true,
      lazyLoad: true
    };

    let imgs = this.props.imgs || [];
    
    const items = imgs.map((item, i) => (
      <div>
        <div className="slider_item" style={{background:`url(${item})`}} key={i}/>
      </div>
    ));
    return (
      <Slider {...settings}>
        {items}
      </Slider>
    );
  }
}

WSlider.defaultProps = {
  title: 'Click',
  type: '',
  img: '',
  onClick: function(title){ alert("Hello"); }
};

export default WSlider;



// WEBPACK FOOTER //
// ./src/components/WSlider/WSlider.js